.root {
  align-items: center;
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-weight: 500;
  font-size: 14px;
  gap: 8px;
  justify-content: center;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;
}

.root-variant-primary {
  background: var(--color-primary);
  color: var(--color-primary-foreground);

  &:hover {
    background: var(--color-primary-hover);
  }
}

.root-variant-secondary {
  background: var(--color-secondary);
  color: var(--color-secondary-foreground);

  &:hover {
    background: var(--color-secondary-hover);
  }
}

.root-variant-outline {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  color: var(--color-foreground);

  &:hover {
    border-color: var(--color-foreground);
  }
}

.root-variant-ghost {
  border: 1px solid var(--color-border-strong);
  color: var(--color-foreground);

  &:hover {
    border-color: var(--color-foreground);
  }
}

.root-variant-link {
  color: var(--color-foreground);

  &:hover {
    background: var(--color-secondary);
  }
}

.root-variant-destructive {
  background: var(--color-destructive);
  color: var(--color-destructive-foreground);

  &:hover {
    background: var(--color-destructive-hover);
  }
}

.root-variant-success {
  background: var(--color-success-alt);
  color: var(--color-background);

  &:hover {
    background: var(--color-success-foreground);
  }
}

.root-size-sm {
  height: 32px;
  padding: 8px 16px;
}

.root-size-default {
  height: 36px;
  padding: 10px 20px;
}

.root-variant-dark {
  background: var(--color-btn-dark);
  color: var(--color-background);

  &:hover {
    background: var(--color-btn-dark-hover);
  }
}

.root-variant-light {
  background: var(--color-secondary-hover);
  border: 1px solid var(--color-secondary-hover);
  color: var(--color-btn-dark);

  &:hover {
    border-color: var(--color-foreground);
  }
}

.root-size-lg {
  height: 40px;
  padding: 12px 24px;
}

.root-size-xl {
  height: 44px;
  padding: 12px 24px;
}

.root-size-icon {
  height: 36px;
  width: 36px;
}

.root-size-icon-sm {
  height: 28px;
  padding: 0;
  width: 28px;
}

.root-is-disabled {
  opacity: 0.5;
  pointer-events: none;
}
